<template>
    <div
        class="product no-link-active"
        :class="{
            'product--has-back': secondImage,
        }">
        <div class="product__stock-status">
            <div class="product__sale text_11 text_11--sm-9" v-if="discount_price && discountPercent">
                <!-- {{ "-" + discountPercent + "%" }} -->
                sale
            </div>
            <div class="product__new text_11 text_11--sm-9" v-if="data.site_exclusive">site exclusive</div>
            <div class="product__new text_11 text_11--sm-9" v-if="data.is_restoked">restoked</div>
            <div class="product__new text_11 text_11--sm-9" v-if="data.is_new && !isDrop">new</div>
            <div class="product__reborn text_11 text_11--sm-9 reborn" v-if="data.is_reborn">re:born</div>

            <div class="product__new text_11 text_11--sm-9" v-if="isSoldOut">
                {{ data.soon ? $t("soon") : $t("sold_out") }}
            </div>

            <div
                class="product__new text_11 text_11--sm-9"
                v-if="isDrop"
                v-html="
                    keyedDrops[data.drops[0].slug] && keyedDrops[data.drops[0].slug].text
                        ? keyedDrops[data.drops[0].slug].text
                        : ''
                "></div>

            <div class="product__status text_11" v-if="data.preorder">
                <div class="status--preorder text_9 status position_static">
                    {{ $t("preorder") }}
                </div>
            </div>
            <div class="product__status text_11" v-if="data.is_only_online">
                <div class="status--online text_9 status position_static">
                    {{ $t("online") }}
                </div>
            </div>
        </div>
        <div class="product__wishlist">
            <WishlistHeart :itemId="data.id" :itemSlug="availSlug" />
        </div>

        <div
            class="product__image"
            @click="trackClick()"
            :class="{ 'product__image--box-shadow-none': !hasImageBoxShadow }">
            <div v-if="!$device.isDesktop && !showBuyBlock" @click="showBuyBlock = true" class="product__show-buy">
                <svg-icon name="plus--18" width="18" height="18" />
            </div>
            <component
                :is="openInModal ? 'a' : 'nuxt-link'"
                :to="link"
                :href="link"
                draggable="false"
                class="product__link like-link"
                @click="loadProductModal($event, availSlug)"
                :target="openInNewTab ? '_blank' : null">
                <div v-if="imagesForSlides.length" class="product__imgs-slider">
                    <div v-for="(img, index) in imagesForSlides" :key="`image-${index}`" class="product__imgs-slide">
                        <UiImage
                            draggable="false"
                            :class="{ 'instant-load': !!index }"
                            width="100%"
                            lazy
                            :alt="data.product.name"
                            :path="img.path"
                            :mobile="cropSize.m"
                            :desktop="cropSize.d"></UiImage>
                    </div>
                </div>
            </component>
            <!-- Перемещаем контент напрямую в тег body -->

            <transition name="fade">
                <div
                    v-if="$device.isDesktop || showBuyBlock"
                    class="product__buy"
                    v-click-outside="() => (!$device.isDesktop ? (showBuyBlock = false) : null)">
                    <div class="product__buy-content text_13">
                        <div class="product__buy-sizes flex-c">
                            <!--
                                    in_stock
                                    is_active
                                    is_always_available
                                    is_soldout
                                    -->
                            <div
                                v-for="s in sizes"
                                :key="s.size_id"
                                @click="onSizeClick(s)"
                                class="button button--gray"
                                :class="{
                                    'button--notify':
                                        (!s.is_active || !s.in_stock || s.is_soldout || s.soon) &&
                                        !s.is_always_available,
                                    'button--current': s.size_id === selectedSize?.size_id,
                                }">
                                {{ s.name }}
                            </div>
                        </div>

                        <transition name="fade">
                            <div v-if="reachlimit" class="product__buy-limit color-red text_11">
                                {{ $t("overload_items") }}
                            </div>
                        </transition>
                    </div>
                </div>
            </transition>
        </div>
        <div class="product__bottom">
            <div class="product__bottom-left">
                <div class="product__info">
                    <div class="product__title text_11">
                        {{ data.product.name }}
                    </div>
                </div>

                <!-- Для индексации -->
                <input type="hidden" data-name="name" :value="data.product.name" />
                <input type="hidden" data-name="price" :value="price.toLocaleString('ru-RU') + currency" />
                <!-- Для индексации -->
            </div>

            <div
                class="product__price"
                :class="{
                    hidden: data.noprice,
                }">
                <div
                    class="product__discount-price product__discount-price--red text_11--sm-9 text_bold"
                    v-if="discount_price">
                    <div class="product__full-price text_9">
                        {{ price.toLocaleString("ru-RU") }}
                        <span class="money">{{ currency }}</span>
                    </div>
                    {{ discount_price.toLocaleString("ru-RU") }}
                    <span class="money">{{ currency }}</span>
                </div>
                <div class="product__discount-price text_11--sm-9 text_bold" v-else>
                    {{ price.toLocaleString("ru-RU") }}
                    <span class="money">{{ currency }}</span>
                </div>
            </div>

            <div class="product__color-name text_11">
                {{ data.color.name }}
            </div>
            <div class="product__colors">
                <component
                    :is="openInModal || openInModal ? 'a' : 'nuxt-link'"
                    :class="`product__color like-link`"
                    v-for="(color, id) in exist_skus"
                    :to="`/product/${color.sizes[0].sku_slug}/`"
                    :href="`/product/${color.sizes[0].sku_slug}/`"
                    :key="id"
                    @click="loadProductModal($event, color.sizes[0].sku_slug)">
                    <CrystalIcon
                        :is-active="color.color_id === data.color.id"
                        :color="color.code"
                        :secondary-color="color.secondary_code" />
                    <div v-if="$device.isDesktop" class="product__color-label text_9">
                        {{ color.name }}
                    </div>
                </component>

                <span class="text_11"
                    >{{ exist_skus.length }}
                    {{ exist_skus.length | pluralize([$t("colors1"), $t("colors2"), $t("colors5")]) }}</span
                >
            </div>
        </div>
    </div>
</template>
<script>
import WishlistHeart from "~/components/WishlistHeart";
import UiImage from "@/components/ui/Image";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import CrystalIcon from "./CrystalIcon.vue";
export default {
    name: "Product",
    props: {
        data: {
            type: Object,
        },
        isForSlider: {
            type: Boolean,
            default: false,
        },
        index: {
            type: [String, Number],
            default: "1",
        },
        openInModal: {
            type: Boolean,
            default: false,
        },
        openInNewTab: {
            type: Boolean,
            default: false,
        },
        isManualLazyImage: {
            type: Boolean,
            default: false,
        },
        hasImageBoxShadow: {
            type: Boolean,
            default: true,
        },
        isTotalLook: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CrystalIcon,
        WishlistHeart,
        UiImage,
    },
    data() {
        return {
            categoryImage: this.data.waist_high_image || null,
            categoryBackImage: this.data.waist_high_back_image || null,
            secondImage: this.data.images?.[0]?.path || null,
            addDisabled: false,
            selectedSize: null,
            reachlimit: false,
            showBuyBlock: false,
        };
    },
    computed: {
        ...mapGetters({
            locale: "globalvars/getLocale",
            currency: "globalvars/getCurrency",
        }),
        ...mapState("collections", ["keyedDrops"]),
        isProductInCart() {
            return !!this.itemsInCart()[this.selectedSize?.sku_id];
        },
        sizes() {
            const sku = this.exist_skus.find((sku) => sku.color_id === this.data.color.id);
            if (sku) {
                return sku.sizes;
            }
            return null;
        },
        imagesForSlides() {
            if (this.isForSlider && !this.$device.isDesktop && this.data.images) {
                return [this.data.images[0]];
            }
            return this.data.images?.slice(0, 6) || [];
        },
        gender() {
            if (this.$route.query.gender) {
                return this.$route.query.gender;
            }

            if (this.$route.name.includes("woman")) {
                return "woman";
            }
            if (this.$route.name.includes("man")) {
                return "man";
            }
            return "all";
        },
        defaultPath() {
            const path =
                this.isCategories && this.categoryImage
                    ? this.categoryImage
                    : this.isTotalLook
                    ? this.totalLookImage
                    : this.secondImage;

            return this.$img.resizeSimple(path, this.$device.isDesktop ? (1260, 1900) : (475, 713));
        },
        firstImage() {
            if (this.activeColor >= 0 && this.exist_skus[this.activeColor]) {
                return this.exist_skus[this.activeColor].sizes[0]?.images[0]?.path;
            }
            return this.data.back_image ? this.data.back_image.path : "";
        },
        totalLookImage() {
            if (this.data.images[1]) {
                return this.data.images[1].path;
            }
            return this.secondImage;
        },
        exist_skus() {
            return this.data.product.skus;
            // return this.data.product.skus.filter((el) => {
            //     return el.sizes.filter((size) => {
            //         return size.in_stock;
            //     }).length;
            // });
        },
        isDrop() {
            return this.data.drops && this.data.drops.length;
        },
        discount_price() {
            if (this.locale) {
                return this.data.currencies[this.locale.currency.currencyCode].discount_price;
            }
            return "";
        },
        price() {
            if (this.locale) {
                return this.data.currencies[this.locale.currency.currencyCode].price;
            }
            return "";
        },
        total_instok() {
            return this.$grom.checkExisting(this.data);
        },
        isAgenderPage() {
            return this.$route.path.includes("collections=agndr");
        },
        link() {
            let link = `/product/${this.data.slug}/`;

            if (this.availSize) {
                link = `/product/${this.availSize.sku_slug}/`;
            }

            if (this.gender && !this.isAgenderPage) {
                link += `?gender=${this.gender}`;
            }
            return link;
        },
        availSlug() {
            if (this.availSize) {
                return this.availSize.sku_slug;
            }
            return this.data.slug;
        },
        availSize() {
            let color_size = this.data.product.skus.find((el) => el.slug === this.data.slug);
            let in_stock_item = color_size ? color_size.in_stock > 0 && color_size.is_active : false;
            return in_stock_item ? in_stock_item : false;
        },
        cropSize() {
            return {
                d: { width: 630, height: 950 },
                m: { width: 216, height: 324 },
            };
        },
        isCategories() {
            return this.$route?.params?.pathMatch?.split("=")[0] === "categories";
        },
        discountPercent() {
            return Math.round(100 - (this.discount_price * 100) / this.price) || "";
        },
        isSoldOut() {
            const skus = this.data.product.skus;

            if (this.data.color && this.data.color.id) {
                const colorSku = skus.find((sku) => sku.color_id === this.data.color.id);

                if (!colorSku) return true;

                return colorSku.sizes.every((size) => {
                    if (!this.data.preorder) {
                        return Boolean(size.in_stock <= 0 || size.is_soldout);
                    }
                });
            }

            return skus.every((sku) => {
                return sku.sizes.every((size) => {
                    if (!this.data.preorder) {
                        return Boolean(size.in_stock <= 0 || size.is_soldout || size.soon);
                    }
                });
            });
        },
    },
    methods: {
        ...mapActions({
            setNotify: "notify/setNotify",
            setOrder: "order/setOrder",
            addItemToDb: "order/addItemToDb",
            toggleFreshItem: "order/toggleFreshItem",
        }),
        ...mapMutations("crumbs", { updateCrumbs: "change" }),
        ...mapGetters({
            itemsInCart: "order/getItems",
        }),
        onSizeClick(selectedSize) {
            if (
                this.isSoldOut ||
                ((!selectedSize?.is_active ||
                    !selectedSize?.in_stock ||
                    selectedSize?.is_soldout ||
                    selectedSize?.soon) &&
                    !selectedSize?.is_always_available)
            ) {
                this.setNotify({ size: selectedSize.name, id: selectedSize.sku_id });
                this.showBuyBlock = false;
            } else {
                this.addItemToCart(selectedSize);
            }
        },
        async addItemToCart(selectedSize) {
            let key = selectedSize.sku_id;
            let item = {
                key: key,
                id: selectedSize.sku_id,
                slug: selectedSize.sku_slug,
                sizeId: selectedSize.size_id,
                sizeName: selectedSize.name,
                count: 1,
            };
            let exist_item = this.$store.getters["order/getItem"](key);

            if (exist_item) {
                item.count += exist_item.count;
            }
            if (item.count > selectedSize.in_stock && !selectedSize.is_always_available) {
                setTimeout(() => {
                    this.reachlimit = false;
                }, 3000);
                return;
            }

            this.addItemToDb(item);
            this.setOrder();
            await this.toggleFreshItem();
            this.showBuyBlock = false;
            window.$sendRetailCRMEvent("cart", {
                cart_id: "",
                items: [
                    {
                        external_id: selectedSize.sku_id.toString(),
                        price: this.data.discount_price ? this.data.discount_price : this.data.price,
                        quantity: item.count,
                    },
                ],
            });
            this.$grom.reachEcommerce("add", {
                products: [
                    {
                        name: this.data.product.name, // Название товара
                        id: selectedSize.sku_id.toString(), // Идентификатор товара
                        price: this.data.discount_price
                            ? this.data.discount_price.toFixed(2)
                            : this.data.price.toFixed(2), // Стоимость товара
                        brand: "post-post-scriptum", // Название бренда
                        category: this.data.product.category ? this.data.product.category.name : "", // Категория
                        variant: `${selectedSize.name} ${this.data.color?.name}`, // Размер, цвет
                        list: this.data.product.collection?.name || "Без коллекции", // Список
                        quantity: 1, // Количество добавленных единиц
                    },
                ],
            }); // Яндекс.Метрика: добавление в корзину
            var _tmr = window._tmr || (window._tmr = []);
            _tmr.push({
                type: "reachGoal",
                id: 3426814,
                value: this.data.discount_price ? this.data.discount_price.toFixed(2) : this.data.price.toFixed(2),
                goal: "addToCart",
                params: { product_id: selectedSize.sku_id.toString() },
            });
        },

        disableLink(e) {
            e.preventDefault();
            return false;
        },
        async loadProductModal(event, slug) {
            if (
                this.openInNewTab ||
                event.ctrlKey || // Ctrl + Click (Windows/Linux)
                event.metaKey || // Cmd + Click (macOS)
                event.button === 1 // Средняя кнопка мыши (wheel click)
            ) {
                return; // переход произойдет автоматически благодаря :to и target="_blank"
            }

            if (this.openInModal) {
                event.preventDefault();
                //отрубаем скролл страницы
                // прячем фильтр
                const fullProduct = await this.$store.dispatch("catalog/getProductPageData", {
                    slug,
                    gender: this.isAgenderPage ? "all" : this.gender,
                });

                this.$emit("update:showProductDetails", {
                    mimicry: true,
                });
                this.$store.commit("catalog/updateNeedUpdateCatalog", false);
                this.$store.commit("catalog/updateProductModal", fullProduct);
            }
            return true;
        },

        trackClick() {
            console.log(`this.availSize =>`, this.data);
            this.$gtm.push({
                event: "productClick",
                ecommerce: {
                    click: {
                        actionField: { list: this.data.product.collection?.name || "Без коллекции" }, // Наследуемое изменяемое поле - значения выше
                        products: [
                            {
                                name: this.data.product.name,
                                id: this.availSize ? this.availSize.sku_id.toString() : this.data.id.toString(),
                                price: this.data.discount_price
                                    ? this.data.discount_price.toFixed(2)
                                    : this.data.price.toFixed(2),
                                brand: "post-post-scriptum",
                                category: this.data.product.category ? this.data.product.category.name : "",
                                variant: `${this.availSize ? this.availSize.name : this.data.size?.name} ${
                                    this.data.color?.name
                                }`, // Размер, цвет
                                position: this.index.toString(), // Позиция товара, считая от левого верхнего угла.           СТРОГО со значения 1.
                            },
                        ],
                    },
                },
            });
        },
    },
    created() {
        this.$nuxt.$on("update-location-href", () => {
            this.$store.commit("catalog/updateProductModal", null);
        });
    },
    mounted() {
        window.addEventListener(
            "popstate",
            () => {
                this.$store.commit("catalog/updateProductModal", null);
            },
            false
        );
    },
    beforeDestroy() {
        window.removeEventListener(
            "popstate",
            () => {
                this.$store.commit("catalog/updateProductModal", null);
            },
            false
        );
    },
};
</script>
<style scoped lang="less">
.product__imgs-slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 1;
    &:not(:hover) {
        .product__imgs-slide:first-child {
            picture {
                display: block;
            }
        }
    }
    &:hover {
        .product__imgs-slide {
            &::before {
                opacity: 0.3;
            }
            &:hover {
                &::before {
                    opacity: 1;
                }
                picture {
                    display: block;
                }
            }
        }
    }

    @media @sm {
        position: static;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
    }
}
.product__imgs-slide {
    position: static;
    scroll-snap-align: start;
    min-width: 0;
    flex-grow: 1;
    @media @sm {
        width: 100%;
        flex-shrink: 0;
    }

    &::before {
        content: "";
        display: block;
        height: 2px;
        background: @text_3;
        opacity: 0;
        position: relative;
        z-index: 4;
        @media @sm {
            display: none;
        }
    }
    &:first-child:last-child:before {
        display: none;
    }

    picture {
        pointer-events: none;
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        @media @sm {
            position: static;
            display: block;
        }
    }
}

.product:not(#productPage) {
    isolation: isolate;
    color: inherit !important;
    position: relative;
    user-select: none;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media @notsm {
        &:hover {
            .product__buy {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

    &.product--has-back {
        @media @notsm {
            &:hover {
                .product__image .product__link {
                    opacity: 1;
                }
            }
        }
    }

    .product {
        &__buy {
            background: #ffffffcc;
            text-align: center;
            position: absolute;
            bottom: 0;
            transform: translateY(20%);
            opacity: 0;
            left: 0;
            right: 0;
            z-index: 2;
            @media @sm {
                opacity: 1;
                transform: translateY(0);
            }
            &-content {
                flex-shrink: 0;
                padding: 16px;
                @media @sm {
                    padding: 8px;
                }
            }
            &-limit {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 16px;
                text-align: center;
                background: #000;
            }
            &-sizes {
                gap: 4px;
                justify-content: center;
                flex-wrap: wrap;
                @media @sm {
                    flex-wrap: nowrap;
                    overflow-x: auto;
                }
                .button {
                    width: auto;
                    height: 32px;
                    min-width: 32px;
                    padding: 5px;
                    &:hover {
                        border-color: @red2;
                    }
                    &--notify {
                        position: relative;
                        color: @border2;
                        border-color: @border2;
                        background-image: linear-gradient(
                            to bottom right,
                            transparent calc(50% - 0.5px),
                            @border2 calc(50% - 0.5px),
                            @border2 calc(50% + 0.5px),
                            transparent calc(50% + 0.5px)
                        );
                    }
                    &--current {
                        color: @red2;
                        border-color: @red2;
                    }
                }
            }
        }

        &__link {
            -webkit-user-drag: none;
        }

        &__stock-status {
            position: absolute;
            pointer-events: none;
            top: 0;
            left: 0;
            display: flex;
            z-index: 2;
            gap: 26px;
            flex-wrap: wrap;
            padding: 26px 64px 0 24px;
        }
        &__show-buy {
            position: absolute;
            padding: 15px;
            bottom: 0;
            right: 0;
            z-index: 3;
            svg {
                display: block;
            }
        }

        &__status {
            &:has(+ .product__status) .status {
                right: 105px;
                @media @sm {
                    right: 85px;
                }
            }

            & + .product__status + .status {
                right: 105px;
                @media @sm {
                    right: 85px;
                }
            }

            margin-bottom: 16px;
            @media @sm {
                margin-bottom: 0;
            }

            &:has(.position_static) {
                margin-bottom: 0;
            }
        }
        &__info {
            display: flex;
            flex-direction: column;
            gap: 8px;
            @media @sm {
                height: 100%;
            }
        }
        &__color-name {
            grid-area: color;
        }
        &__colors {
            grid-area: colors;

            display: flex;
            z-index: 1;
            gap: 5px 0;
            flex-wrap: wrap;
            align-items: center;
        }

        &__color {
            margin-right: 8px;
            position: relative;

            &:hover {
                .product__color-label {
                    opacity: 1;
                    transform: translateY(-6px);
                }
            }
        }

        &__color-label {
            position: absolute;
            opacity: 0;
            bottom: 100%;
            z-index: 1;
            background: #000;
            border-radius: 3px;
            padding: 3px 4px;
            left: -3px;
            color: #fff;
            white-space: nowrap;
            transform: translateY(0);
            pointer-events: none;
            .trs(all);
        }

        &__wishlist {
            position: absolute;
            display: flex;
            align-items: center;
            z-index: 3;
            top: 16px;
            right: 16px;
            cursor: pointer;

            svg {
                display: block;
            }

            @media @sm {
                top: 8px;
                right: 8px;
            }
        }

        &__image {
            z-index: 1;
            position: relative;
            top: 0;
            left: 0;
            aspect-ratio: 540 / 813;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            overflow: hidden;
            @media @sm {
                height: auto;
                position: relative;
                box-shadow: none;
                &.isLoaded {
                    background-size: cover;
                }
            }

            .product__link {
                display: block;
                height: 100%;
                @media @sm {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                -webkit-user-drag: none;
            }

            &--box-shadow-none {
                box-shadow: none;
            }
        }

        &__art {
            margin-bottom: 8px;
        }

        &__price {
            grid-area: price;

            text-align: right;
            white-space: nowrap;
            position: relative;
            @media @sm {
                position: static;
                order: 2;
            }
        }

        &__full-price {
            display: inline-block;
            position: absolute;
            right: 0;
            top: 12px;
            color: #000;
            &:before {
                left: 0;
                top: 50%;
                right: 0;
                content: "";
                height: 1px;
                margin-top: -1px;
                position: absolute;
                background: #000;
            }

            @media @sm {
                margin-left: 4px;
                order: 1;
                top: 0;
                position: relative;
            }
        }

        &__discount-price {
            &--red {
                color: @red2;
            }

            @media @sm {
                display: flex;
                align-items: baseline;
                > span {
                    padding-left: 4px;
                }

                br {
                    display: none;
                }
            }
        }

        &__bottom {
            flex-grow: 1;
            z-index: 2;
            position: relative;

            background: #fff;
            padding: 16px 30px;
            display: grid;
            grid-template-areas: "name price" "color color" "colors colors";
            gap: 8px;
            @media @sm {
                text-align: left;
                color: #000;
                padding: 8px 16px 11px;
                display: flex;
                flex-direction: column;
            }

            &-left {
                grid-area: name;
                @media @sm {
                    flex-grow: 1;
                }
            }
            &-statuses {
                position: absolute;
                right: 0;
                bottom: 100%;
                padding: 8px;
                .status {
                    margin-bottom: 0;
                    margin-top: 3px;
                    position: relative;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    @media @sm {
                        bottom: 3px;
                        right: 3px;
                    }
                }
            }
        }

        &__sale {
            color: @red2;
        }

        &__new {
            color: #000;
        }

        &__reborn {
            color: #6cbe46;
        }

        &__sale + &__new {
            display: none;
        }
    }
}

.status {
    border: 1px solid;
    display: inline-block;
    padding: 4px 7px;
    margin-bottom: 3px;
    position: absolute;
    bottom: 55px;
    right: 25px;
    transition: 0.2s;
    z-index: 1;

    &--online:hover {
        color: @purple;
    }

    @media @sm {
        bottom: 5px;
        margin-bottom: 0;
        right: 5px;
        top: unset;
    }

    &.position_static {
        margin-bottom: 3px;
    }
}

.hidden {
    visibility: hidden;
}

.position_static {
    position: static;
}
</style>
